'use client';
import { useClickOutside } from '@/hooks/useClickOutside';

import HeaderItemSB from '@/components/atoms/layout/header/HeaderItemSB';
import { HeaderProps } from '@/components/atoms/layout/header/HeaderSB';
import { Overlay } from '@/components/atoms/overlay';
import { BlockComponentModel } from '@/components/cms/types/blok-component';

interface HeaderItemListSBProps {
  firstLevel: HeaderProps['header']['firstLevels'][number];
}

export type HeaderItemListSBExtraProps = {
  headerRef: React.RefObject<HTMLDivElement | null>;
  hasMenuOpen: boolean;
  onMenuClick: (index?: number) => void;
  onClose: () => void;
};

export default function HeaderItemListSB({
  block,
  ...rest
}: BlockComponentModel<HeaderItemListSBProps> & HeaderItemListSBExtraProps) {
  const { firstLevel } = block;
  const { headerRef, onMenuClick, onClose, hasMenuOpen } = rest;

  useClickOutside({
    ref: headerRef as React.MutableRefObject<HTMLElement>,
    callback: () => {
      onClose?.();
    },
    excludeDataAttr: ['data-header-blur-background'],
  });

  return (
    <div>
      <HeaderItemSB
        block={firstLevel}
        isOpen={!!hasMenuOpen}
        onClick={() => onMenuClick?.()}
      />
      {hasMenuOpen && <Overlay />}
    </div>
  );
}
